import React from "react";
import { Link } from "react-router-dom";
import TeamData from "../../data/team/TeamData.json";
import { slugify } from "../../utils";

const allData = TeamData;

const managementTeam = allData.filter(
  (member) => member.category === "management"
);
const internalStaff = allData.filter(
  (member) => member.category === "internal"
);

const TeamOne = () => {
  const renderTeamSection = (title, teamArray) => (
    <>
      <div
        className="section-heading heading-light"
        style={{ marginTop: "40px" }}
      >
        <h3 className="title mb--30">{title}</h3>
      </div>
      <div className="row">
        {teamArray.map((data) => (
          <div className="col-xl-3 col-sm-6" key={data.id}>
            <div className="team-grid">
              <div className="thumbnail">
                <Link to={""}>
                  <img
                    src={process.env.PUBLIC_URL + data.thumb}
                    alt={data.title}
                  />
                </Link>
              </div>
              <div className="content">
                <h4 className="title">
                  <Link to={""}>{data.title}</Link>
                </h4>
                <span
                  className="designation"
                  dangerouslySetInnerHTML={{ __html: data.designation }}
                ></span>
                <span
                  className="designation"
                  style={{ color: "#ffffff" }}
                  dangerouslySetInnerHTML={{ __html: data.place }}
                ></span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="section section-padding bg-color-dark pb--70 pb_lg--20 pb_md--0">
      <div className="container">
        <div className="section-heading heading-light">
          <span className="subtitle">Our values</span>
          <h2 className="title mb--50">Meet The Team</h2>
          <p>
            Our team is a group of passionate experts dedicated to turning your
            ideas into reality. With creativity, skill, and commitment, we
            deliver solutions that exceed expectations and drive success. Let’s
            achieve greatness together!
          </p>
        </div>
        {renderTeamSection("Management Team", managementTeam)}
        {renderTeamSection("Internal Staff", internalStaff)}
      </div>

      <ul className="list-unstyled shape-group-10">
        <li className="shape shape-1">
          <img
            src={process.env.PUBLIC_URL + "/images/others/circle-1.png"}
            alt="Circle"
          />
        </li>
        <li className="shape shape-2">
          <img
            src={process.env.PUBLIC_URL + "/images/others/line-3.png"}
            alt="Circle"
          />
        </li>
        <li className="shape shape-3">
          <img
            src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"}
            alt="Circle"
          />
        </li>
      </ul>
    </div>
  );
};

export default TeamOne;
